import React from 'react';
import { motion } from 'framer-motion';

const Reveal = ({ children, delay = 0, y = 40, className = '', as: Tag = 'div' }) => {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
